module.exports = __webpack_public_path__ + "static/media/motor-data-icon.ab6d9bc1.png";